namespace TimeUtil {
  export const delay = async (millis: number) => {
    return new Promise((resolve) => {
      setTimeout(resolve, millis);
    });
  };
}

export default TimeUtil;
